import { InputSwitch, InputSwitchChangeEvent, InputSwitchProps } from 'primereact/inputswitch'
import React, { FC } from 'react'

type Props = {
    checked: boolean
    onChange: (event: InputSwitchChangeEvent) => void
    disabled?: boolean
    loading?: boolean
    label?: string
    inputId: string
} & InputSwitchProps

export const Switch: FC<Props> = ({ checked, onChange, disabled, loading, label, inputId, ...props }) => {
    return (
        <div className="flex align-items-center gap-2">
            <InputSwitch
                checked={checked}
                onChange={onChange}
                disabled={loading || disabled}
                inputId={inputId}
                {...props}
            />
            {loading ? <i className="pi pi-spin pi-spinner text-lg"></i> : null}
            <label className="m-0" htmlFor={inputId}>
                {label}
            </label>
        </div>
    )
}
